<template>
  <page-outline :title="$t('attachments.import_file')">
    <template slot="pageContent">
      <b-row class="justify-content-start">
        <b-col xl="2" offset="2" class="pt-2 my-1 mr-5 font-weight-bold">
          <label class="text-dark">{{ $t('common.chse_file_up') }}</label> *
        </b-col>
        <b-col xl="4" class="mr-5 form-group">
            <input class="form-control" ref="fileInput" type="file" name="file2" id="file2"  @change="onFileChange" accept=".csv"></input>
        </b-col>
        <b-col xl="1" class="ml-5 form-group text-center">
          <b-button variant="primary" size="lg" style="width: 135px"
              @click="importAttachment">
            <span>{{$t('bank_accounts.imprt')}}</span>
          </b-button>
        </b-col>
        <b-col xl="12" offset="2">
          <i>{{ $t('common.asterisk_obligation_label') }}</i>
        </b-col>
      </b-row>
      <br/>
      <br/>
    </template>
  </page-outline>
</template>
<script>
import PageOutline from '@/components/common/PageOutline.vue'
import {loadPage} from '@/helpers/routing'

export default {
  name: 'ImportFiles',
  components: {
    'page-outline': PageOutline
  },
  data () {
    return {
      mimeType: '',
      attachment: '',
      attachmentName: '',
      isSmartphone: false,
      report: []
    }
  },
  created () {
    if (this.$engine.services.directPayments.filter.smartphoneStorage) {
      this.isSmartphone = true
    }
    this.mimeType = ''
    this.attachment = ''
    this.attachmentName = ''
    // this.$refs.fileInput.value = null
  },
  methods: {
    importAttachment () {
      let that = this
      console.log(that.attachment, that.attachmentName)
      if (that.attachment !== '' && that.attachmentName !== '') {
        // var lines = that.attachment.split('\n')
        // for (var i = 0; i < lines.length; i++) {
        //   if (i > 0) {
        //     var csvs = lines[i].split(';')
        //     if (csvs.length > 1) {
        //       if (csvs.length === 15) {
        //         that.addAccount(csvs[0], csvs[10] + csvs[11] + csvs[3], csvs[9], i + 1)
        //       } else {
        //         // that.report += 'Line ' + (i + 1) + ': ' + csvs[0] + ' invalid value number\n'
        //         var objReport3 = {line: i + 1, name: csvs[0], iban: csvs[10] + csvs[11] + csvs[3], status: 0, description: 'invalid value number'}
        //         that.report.push(objReport3)
        //       }
        //     }
        //   }
        // }
        // this.mimeType = ''
        // this.attachment = ''
        // this.attachmentName = ''
        // this.$engine.bankAccounts.setImportReport(that.report)
        // this.$bus.emit('refresh-bank-accounts-import-report')
        // loadPage(that, {url: '/bankAccounts/importReport/', force: false, ignoreCache: false})
        let file = btoa(that.attachment)
        //let data = file.split(';base64,')[1]
        this.$engine.pacs008.importSDD(
          this.attachmentName,
          file
        ).then(resp => {
          loadPage(that, {url: '/pacs008/SDD/traitement/'})
        })
      } else {
        that.$f7.alert('', 'Data missing')
      }

      var file = this.$refs.fileInput.files[0]
      if (file.type !== "text/csv") {
        that.$f7.alert('Veuillez sélectionner un fichier CSV', 'Erreur du type du fichier')
        return
      }
    },
    // addAccount (name, iban, zone, line) {
    //   var error = ''
    //   // Create account
    //   this.$engine.bankAccounts
    //     .create({
    //       name: name,
    //       iban: iban,
    //       zoneCode: zone
    //     })
    //     .then(resp => {
    //       var objReport = {line: line, name: name, iban: iban, status: 1, description: 'Added'}
    //       this.report.push(objReport)
    //       // that.$bus.$emit('refresh-cache-bank-accounts')
    //       /* this.$f7.modal({
    //         title: 'Adding account',
    //         text: '<span class="preloader"></span>'
    //       })
    //       setTimeout(function () {
    //         that.$f7.closeModal()
    //         loadPage(that, {url: '/bankAccounts/', force: false, ignoreCache: false})
    //       }, 2000) */
    //     })
    //     .catch(err => {
    //       var objReport = {line: line, name: name, iban: iban, status: 0, description: err.response.statusText}
    //       this.report.push(objReport)
    //       // errorMessageAlert(err, that)
    //     })
    //   return error
    // },
    onFileChange (e) {
      /* eslint-disable no-undef */
      let that = this
      var files = e.target.files || e.dataTransfer.files
      if (!files.length) { return }
      if (files[0].size <= 1000000) {
        that.createImage(files[0])
        that.attachmentName = files[0].name
        that.mimeType = files[0].type
      } else {
        that.$f7.alert('This file has a size of ' + Math.round(files[0].size / 1000) + 'Kb. \n Maximum permited is 1MB', 'Maximum file size exceeded')
      }
      var file = e.target.files[0]
      if (!file || !file.type || file.type !== 'text/csv') {
        that.$f7.alert('Veuillez sélectionner un fichier CSV', 'Erreur du type du fichier')
        return
      }
    },
    createImage (file) {
      let reader = new FileReader()
      let that = this
      this.$f7.modal({
        title: 'Charging File',
        text: '<span class="preloader"></span>'
      })
      reader.onload = (e) => {
        that.attachment = e.target.result
        that.$f7.closeModal()
      }
      reader.readAsBinaryString(file)
    }
  }
}
</script>
